import React, { useState, useCallback, useEffect } from 'react';
import ReactQuill from 'react-quill-new';
import DOMPurify from 'dompurify';
import axios from 'axios';
import { baseAPI } from '../config';
import { toast } from 'react-toastify';
import 'react-quill-new/dist/quill.snow.css';

const TOOLBAR_OPTIONS = [
  ['bold', 'italic', 'underline'],
  [{ list: 'bullet' }],
  ['link'],
];

const QUILL_MODULES = {
  toolbar: TOOLBAR_OPTIONS,
};

const QUILL_FORMATS = ['bold', 'italic', 'underline', 'list', 'link'];

function ExpedientNotesEditor({ expedientId, initialNotes }) {
  const [notes, setNotes] = useState(initialNotes || '');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setNotes(initialNotes || '');
  }, [initialNotes]);

  const handleChange = useCallback((value) => {
    setNotes(value);
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      const sanitized = DOMPurify.sanitize(notes);
      await axios.post(
        `${baseAPI}/expedients/update/${expedientId}`,
        { notes: sanitized },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      toast.success('Notas guardadas');
    } catch (error) {
      console.error('Error saving notes:', error);
      toast.error('Error al guardar las notas');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className='[&_.ql-editor]:min-h-[100px]'>
      <ReactQuill
        theme='snow'
        value={notes}
        onChange={handleChange}
        modules={QUILL_MODULES}
        formats={QUILL_FORMATS}
        placeholder='Escribe notas internas...'
      />
      <div className='flex justify-end mt-2'>
        <button
          type='button'
          onClick={handleSave}
          disabled={saving}
          className='px-3 py-1.5 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 disabled:opacity-50'
        >
          {saving ? 'Guardando...' : 'Guardar notas'}
        </button>
      </div>
    </div>
  );
}

export default ExpedientNotesEditor;
